import React, { FC, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Slider } from '@/_shared/components/Slider';
import { ContentType } from '@/swagger/constants/contents-orchestrator-enums';
import { getContentsInProgressCall } from '../../state';
import { ContentsSkeleton } from '../ContentsSkeleton';
import { ContentToCard } from '../ContentToCard';

type Props = {
  filterType?: `${ContentType}`;
};

export const ContentsInProgress: FC<Props> = ({ filterType }) => {
  const t = useTranslations('trainingHardSkills.sections.contentsInProgress');
  const {
    execute: executeGetContentsInProgress,
    loading: loadingGetContentsInProgress,
    data,
  } = getContentsInProgressCall.hook();

  useEffect(() => {
    executeGetContentsInProgress({
      length: 10,
      filterByTypes: filterType ? [filterType] : undefined,
    });
  }, [executeGetContentsInProgress, filterType]);

  return (
    <Box>
      {loadingGetContentsInProgress ? <ContentsSkeleton halfHeightLayout={false} /> : null}
      {!loadingGetContentsInProgress && data && data.length > 0 ? (
        <>
          <Typography variant='h2' mb='m'>
            {filterType ? t(`${filterType}`) : t('title')}
          </Typography>
          <Slider.SliderBottomRightArrow>
            {data?.map(content => (
              <ContentToCard content={content} key={content.id} />
            ))}
          </Slider.SliderBottomRightArrow>
        </>
      ) : null}
    </Box>
  );
};
